export enum FittingEnableDisableReturnCodes{
    Enable = 0,
    Disable = 1,
    NoSystemDef = 2,
    Error = 3,
}